import { Button } from '@creditornot/cb-button';
import { cssThemedValue, colors } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import CityRushWithBag from 'common/illustrations/CityRushWithBag';
import { Typography as T } from 'common/typography';

import { DraftVenue } from '../../../../apis/merchant-onboarding-service/types';

type Props = {
  draftVenuesGroupedByMerchant: { merchantId: string; merchantName: string; draftVenues: DraftVenue[] }[];
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (width <= 640px) {
    gap: 16px;
  }
`;

const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  max-width: 600px;
  height: 106px;
  border-radius: 8px;
  background-color: ${colors.wolt8};
  padding-block: 16px;
  padding-inline: 16px;

  @media (width <= 640px) {
    height: 100%;
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
`;

const IllustrationContainer = styled.div`
  flex-shrink: 0;
`;

const Content = styled.div`
  flex-grow: 1;
`;

const StyledHeading = styled(T.Heading6)`
  color: ${cssThemedValue('textPrimary')};
  font-size: 18px;
`;

const StyledBody = styled(T.Body3)`
  font-size: 14px;
  color: ${cssThemedValue('textSecondary')};
`;

const StyledButton = styled(Button)`
  width: 135px;
  height: 56px;
  flex-shrink: 0;

  @media (width <= 640px) {
    width: 100%;
    height: 36px;
  }
`;

const DraftVenues = ({ draftVenuesGroupedByMerchant }: Props) => {
  const history = useHistory();

  return (
    <Root>
      {draftVenuesGroupedByMerchant.map(merchant => (
        <Card>
          <IllustrationContainer>
            <CityRushWithBag width={120} />
          </IllustrationContainer>
          <Content>
            <StyledHeading>
              <FormattedMessage id="venue-data-collection.start.info-missing-heading" />
            </StyledHeading>
            <StyledBody>
              <FormattedMessage
                id="venue-data-collection.start.info-missing"
                values={{ merchantName: merchant.merchantName, count: merchant.draftVenues.length }}
              />
            </StyledBody>
          </Content>
          <StyledButton
            variant={'blue'}
            size={'small'}
            onClick={() => history.push(`venue-data-collection/${merchant.merchantId}`)}
          >
            <FormattedMessage id="state.continue" />
          </StyledButton>
        </Card>
      ))}
    </Root>
  );
};

export default DraftVenues;
